export const PHENOTYPE_CATALOGUE_LABEL = 'phenotype catalogue';
